export const IS_DEV_ENV = process && process.env && process.env.NODE_ENV !== 'production';

export const config = {
  appUrl: IS_DEV_ENV
    ? 'http://localhost:1234'
    : 'https://www.includecart.com',

  apiUrl: IS_DEV_ENV
    ? 'http://localhost:5000/includecart/us-central1'
    : 'https://us-central1-includecart.cloudfunctions.net',

  assetsUrl: IS_DEV_ENV
    ? 'http://localhost:1234'
    : 'https://static.includecart.com',

  // Stripe config settings
  stripe: {
    connectClientId: IS_DEV_ENV
      ? 'ca_EzUqZ50wVXRvpyT3VcKFDpAalYcz440n'
      : 'ca_EzUqspgx5unCUos4PIMiFLG8TiCIjdF0',
  },

  stripeScriptUrl: 'https://js.stripe.com/v3/',
};
